import TakeawayOrderSummary from '../../components/TakeawayOrderSummary'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import _ from 'lodash'

import * as merchantActions from '../../actions/components/merchant'
import * as basketActions from '../../actions/components/basket'
import * as campaignActions from '../../actions/components/campaign'

const mapStateToProps = (state) => {
  return {
    ..._.pick(state, ['merchant', 'orders', 'promocodes', 'form', 'query']),
    user: state.user,
    basket: state.basket,
    locale: state.locale,
    takeawayOrders: state.orders,
    campaign: state.campaign,
    form: state.form,
  }
}

const mapDispatchToProps = (dispatch) => {
  const { getTimeslot, getDateRange } = bindActionCreators(merchantActions, dispatch)
  return {
    getTimeslot,
    getDateRange,
    ...bindActionCreators(basketActions, dispatch),
    ...bindActionCreators(campaignActions, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(TakeawayOrderSummary)))



// WEBPACK FOOTER //
// ./src/containers/components/TakeawayOrderSummary.js